// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"c54886e5","524":"59d3c3e4","2692":"ef617ba5","6660":"30cebf34","9870":"54a61bd3"}[chunkId] + ".chunk.css";
};